/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_top_ups_modal_legal_text_part4 = /** @type {(inputs: {}) => string} */ () => {
	return `regulado en EE.UU. Los fondos están protegidos con encriptación criptográfica y solo el titular de la cuenta puede usar/transferir a través de la app de Bloque.`
};

const en_top_ups_modal_legal_text_part4 = /** @type {(inputs: {}) => string} */ () => {
	return `regulated in the US. Funds are protected with cryptographic encryption and only the account holder can use/transfer through the Bloque app.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const top_ups_modal_legal_text_part4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.top_ups_modal_legal_text_part4(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("top_ups_modal_legal_text_part4", locale)
	if (locale === "es") return es_top_ups_modal_legal_text_part4(inputs)
	return en_top_ups_modal_legal_text_part4(inputs)
};
export { top_ups_modal_legal_text_part4 as "top_ups.modal.legal_text_part4" }